import { Schema } from 'further-types/investor';

export const signUpSourcesThatSkipOnboarding = [
  Schema.SignUpSource.Adviser,
  Schema.SignUpSource.Upload,
  Schema.SignUpSource.AddSingleInvestor,
];
